export default __webpack_public_path__ + "static/media/odinass.7a329926.svg";